export default {
  EXTERIOR_COLOR: 10650,
  INTERIOR_COLOR: 1347,
};
